import styled from 'styled-components';
import { Alert } from 'antd';

export const StyledAlert = styled(Alert)`
  margin-bottom: ${({ theme }) => theme.spacing.space_4};
  max-width: ${({ theme }) => theme.size.large};

  &.ant-alert-with-description {
    padding-top: ${({ theme }) => theme.spacing.space_3};
    padding-bottom: ${({ theme }) => theme.spacing.space_3};
  }

  &.ant-alert-success {
    background-color: transparent;
    border-color: ${({ theme }) => theme.palette.neutrals.summit};
  }

  .ant-alert-icon {
    font-size: ${({ theme }) => theme.font.size.large};
  }

  .ant-alert-message {
    font-size: ${({ theme }) => theme.font.size.small};
    font-weight: 600;
    margin-bottom: 0;
  }

  .ant-alert-description {
    font-size: ${({ theme }) => theme.font.size.xsmall};
    line-height: 1.4;
  }
`;
